import * as React from 'react'
import * as classnames from 'classnames'

import Highlighter from '../../../components/highlighter'

export interface ISuggestion {
  link: string
  text: string
  category: string
  type: string
}

interface IProps {
  suggestion: ISuggestion
  styles: any
  focusedIndex: number
  inputValue: string
  onMenuClick: (arg0: ISuggestion, arg1: React.MouseEvent) => void
  handleMenuMouseEnter: (arg0: number) => void
  handleMenuMouseLeave: (arg0: number) => void
  index: number
  showSeparator: boolean
}

const SuggestionsListItem = (props: IProps) => {
  const {
    styles,
    focusedIndex,
    inputValue,
    onMenuClick,
    handleMenuMouseEnter,
    handleMenuMouseLeave,
    index,
    suggestion,
    showSeparator
  } = props

  return (
    <li
      className={classnames(styles.listItem, {
        [styles.focusedListItem]: focusedIndex === index,
        [styles.separator]: showSeparator
      })}
      onMouseDown={event => onMenuClick(suggestion, event)}
      onMouseEnter={() => handleMenuMouseEnter(index)}
      onMouseLeave={() => handleMenuMouseLeave(index)}
    >
      <a
        className="fds-c-text-link -color-dark -decoration-none"
        href={suggestion.link}
      >
        <span className={classnames(styles.suggestionText, 'h-text-truncate')}>
          <Highlighter bold keywords={inputValue.trim().split(' ')}>
            {suggestion.text}
          </Highlighter>
          {suggestion.category && (
            <span
              className={classnames(styles.categoryText, 'h-text-truncate')}
            >
              in {suggestion.category}
            </span>
          )}
        </span>
      </a>
    </li>
  )
}

export default SuggestionsListItem
